import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'config/axios';
import Helmet from 'components/Helmet';
import { useAppDispatch, useAppSelector } from 'hooks/useStore';
import { setAlert } from 'store/error';
import { Bundle, Test } from 'global/types';

import MyTutors from '../MyTutors';
import MyTests from '../MyTests';
import Bundles from '../Bundles';
import './index.css';

const TABS = ['My Tutor', 'My Assignments', 'Upgrade'];

function SAT() {
    const [tabIndex, setTabIndex] = useState(null);
    const [myTests, setMyTests] = useState<Test[]>([]);
    const [bundles, setBundles] = useState<Bundle[]>([]);

    const { user } = useAppSelector(state => state.user);
    const dispatch = useAppDispatch();
    const { state } = useLocation() as {
        state?: { tab?: string; }
    };

    useEffect(() => {
        axios.get('tests/digital/sat/')
            .then(res => {
                const {
                    studentTests,
                    bundles
                } = res.data;
                setMyTests(studentTests);
                setBundles(bundles);
                if (state?.tab) {
                    const index = TABS.findIndex(tab => tab === state.tab);
                    setTabIndex(index === -1 ? 0 : index);
                }
                else {
                    setTabIndex(0);
                }
            })
            .catch(error => {
                dispatch(setAlert(error));
            });
    }, []);

    if (tabIndex === null) return <></>;

    return (
        <div className='layout'>
            <Helmet
                title='Digital SAT Practice Tests | PrepSharp Students'
            />
            <div className='tests'>
                <div className='tests__tabs'>
                    {TABS.map((tab, t) => (
                        <button
                            className={tabIndex === t ? 'tests__tab--active': 'tests__tab'}
                            onClick={() => setTabIndex(t)}
                        >
                            {tab}
                        </button>
                    ))}
                    {/* <button
                        className={tabIndex === 0 ? 'tests__tab--active' : 'tests__tab'}
                        onClick={() => setTabIndex(0)}
                    >
                        My Tutor
                    </button>
                    <button
                        className={tabIndex === 1 ? 'tests__tab--active' : 'tests__tab'}
                        onClick={() => setTabIndex(1)}
                    >
                        My Assignments
                    </button>
                    <button
                        className={tabIndex === 2 ? 'tests__tab--active' : 'tests__tab'}
                        onClick={() => setTabIndex(2)}
                    >
                        Upgrade
                    </button> */}
                    <div className={tabIndex === 0
                        ? 'tests__tabIndicatorLeft'
                        : tabIndex === 1
                        ? 'tests__tabIndicatorMiddle'
                        : 'tests__tabIndicatorRight'
                    }></div>
                </div>
                {tabIndex === 0
                ?   <MyTutors
                        tutors={user.tutors}
                        setTabIndex={setTabIndex}
                    />
                :   tabIndex === 1
                ?   <MyTests 
                        tests={myTests}
                    />  
                :   <Bundles
                        testType='Digital SAT'
                        bundles={bundles}
                    />
                }
            </div>
        </div>
    );
}

export default SAT;